import React from "react";

function Experience() {
  const experiences = [
    {
      title: "Internship at XYZ Law Firm",
      date: "Summer 2023",
      description:
        "Supported attorneys in legal research, document preparation, and client interviews.",
    },
    {
      title: "Judicial Clerk for Judge ABC",
      date: "2022-2023",
      description:
        "Assisted in drafting judicial opinions and analyzing case law.",
    },
  ];

  return (
    <section id="experience" className="my-12">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-center text-gray-900">
          Experience
        </h2>
        <div className="mt-8 space-y-8">
          {experiences.map((exp, index) => (
            <div key={index} className="bg-white shadow rounded-lg p-6">
              <h3 className="text-xl font-semibold text-blue-600">
                {exp.title}
              </h3>
              <p className="text-gray-600 text-sm">{exp.date}</p>
              <p className="mt-2 text-gray-700">{exp.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
